export default "__VITE_ASSET__BS9Nq_X1__"